import { $ } from '../utils/dom';

let firmaDedoEnabled = false;

export function isFirmaDedoEnabled(): boolean {
  return firmaDedoEnabled;
}

function setFirmaDedoEnabled(value: boolean): void {
  firmaDedoEnabled = value;
}

function parseUrlOverride(): boolean | null {
  const raw = new URLSearchParams(window.location.search).get('firmaDedo');
  if (raw == null || raw === '') return null;
  const normalized = raw.trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return null;
}

export async function loadFirmaConfig(): Promise<void> {
  const urlOverride = parseUrlOverride();
  if (urlOverride != null) {
    setFirmaDedoEnabled(urlOverride);
    return;
  }

  try {
    const res = await fetch('/api/autorizaciones/config');
    const data = (await res.json()) as { ok?: boolean; firmaDedoEnabled?: boolean };
    if (data.ok) {
      setFirmaDedoEnabled(data.firmaDedoEnabled === true);
      return;
    }
  } catch {
    /* fallback abajo */
  }

  setFirmaDedoEnabled(false);
}

export function syncFirmaDedoUi(): void {
  const enabled = isFirmaDedoEnabled();
  $('firma-field')?.classList.toggle('hidden', !enabled);

  const submitBtn = $('btn-submit');
  if (submitBtn) submitBtn.textContent = enabled ? 'Revisar y firmar' : 'Revisar y enviar';

  const confirmBtn = $('btn-confirm-submit') as HTMLButtonElement | null;
  if (confirmBtn && confirmBtn.textContent !== 'Enviando…') {
    confirmBtn.textContent = enabled ? 'Firmar y enviar' : 'Confirmar y enviar';
  }

  const subtitle = document.querySelector('.confirm-subtitle');
  if (subtitle) {
    subtitle.textContent = enabled
      ? 'Revisá los datos y firmá con el dedo para enviar.'
      : 'Revisá los datos y confirmá para enviar.';
  }
}
